import React from 'react';

interface Props {
  label: string;
  value: React.ReactNode;
  sub?: string;
}

const ExpertStatMiniCard: React.FC<Props> = ({ label, value, sub }) => (
  <div className="stat-mini-card">
    <span className="stat-mini-card__label">{label}</span>
    <span className="stat-mini-card__value">{value}</span>
    {sub && <span className="stat-mini-card__sub">{sub}</span>}
  </div>
);

export default ExpertStatMiniCard;
